var config = require("../define/config.js");
var logFunctionStore = require("./logfunctionstore.js");

var logger = {};

logFunctionStore.storeLogFunctions("SilentLogger");
logFunctionStore.storeLogFunctions("NativeLogger", window.console);

// set defualt logger
logFunctionStore.applyLogFunctions(config["DEFAULT_LOGGER"], logger);

module.exports = logger;


